import '~/js/modules/stickyNav';

// Variable Declaration
const resortsList = document.getElementById('resorts-list');
const resortsViews = document.getElementById('resorts-views');
const topArticle = document.getElementById('top-article');

// Internals Variables
const internals = {
  view: null,
  albumUrl: {
    swh: 'https://cdn.sandals.com/sandals/v12/images/general/groups/facilities/swh-digi/index.html',
    sbd: 'https://cdn.sandals.com/sandals/v12/images/general/groups/facilities/sbd-digi/index.html',
    sat: 'https://cdn.sandals.com/sandals/v12/images/general/groups/facilities/sat-digi/index.html',
    sgl: 'https://cdn.sandals.com/sandals/v12/images/general/groups/facilities/sgl-digi/index.html',
    btc: 'https://cdn.sandals.com/beaches/v12/images/general/groups/facilities/btc_digi/index.html',
  }
};

// Click handlers
const clickMore = (e) => {
  const node = e.target;

  if (node.classList.contains('learn-more')) {
    e.preventDefault();

    const id = node.getAttribute('href').slice(1);

    internals.view = document.getElementById(id);

    resortsList.style.display = 'none';
    topArticle.style.display = 'none';
    resortsViews.style.display = 'block';
    internals.view.style.display = 'block';
    $(`#${id} .digital-album-container`).addClass('show');

    window.scrollTo(0, internals.view.offsetTop - 160);
  }
};

const clickBack = (e) => {
  const node = e.target;

  if (node.classList.contains('back-btn')) {

    resortsList.style.display = '';
    topArticle.style.display = '';
    resortsViews.style.display = '';
    internals.view.style.display = '';

    $(`#${internals.view.id} .digital-album-container`).removeClass('show');
    $(`#${internals.view.id} .view-digital-album-btn`).removeClass('active');
    $(`#${internals.view.id} .iframe-content`).removeClass('show');
  }
};

const handleClick = function handler(e) {
  e.preventDefault();

  const $this = $(this);
  const $main = $('html, body');
  const $elScrollTo = $('.' + $this.data('scroll-to'));
  const top = $elScrollTo.offset().top;

  $main.animate({
    scrollTop: top - 85
  }, 600);
};

$('.js-scroll-below').on('click', handleClick);

// Event listeners
resortsList.addEventListener('click', clickMore);
resortsViews.addEventListener('click', clickBack);

$('.view-digital-album-btn').on('click', (e) => {
  const { id: resortId } = internals.view;

  $(e.currentTarget).toggleClass('active');

  if (internals.albumUrl[resortId]) {
    const $resortIframe = $(`#${resortId}_digi`);

    $resortIframe.parent().toggleClass('show');
    if (!$resortIframe.attr('src')) {
      $resortIframe.attr('src', internals.albumUrl[resortId]);
    }
  }
});
